import { List, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ClientUserTableModel } from '../../models/client-user-table-model';

interface Props {
  clientUsersDataSource: ClientUserTableModel[];
  isClientDataFetching: boolean;
}

const ClientUserList = ({ isClientDataFetching, clientUsersDataSource }: Props): JSX.Element => {
  const { t } = useTranslation(['common', 'client-users']);

  return (
    <List
      loading={isClientDataFetching}
      bordered={true}
      itemLayout="vertical"
      dataSource={clientUsersDataSource}
      renderItem={item => (
        <List.Item>
          <div>
            <Typography.Text strong>{t('label.name')}: </Typography.Text>
            {item.name}
          </div>
          <div>
            <Typography.Text strong>{t('label.username')}: </Typography.Text>
            {item.username}
          </div>
          <div>
            <Typography.Text strong>{t('label.role')}: </Typography.Text>
            {item.roles.map(role => t(`roles.${role}`, { ns: 'client-users' })).join(', ')}
          </div>
        </List.Item>
      )}
    />
  );
};
export default ClientUserList;
